var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 21,
    viewBox: "0 0 44 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9902 2.54946C43.5184 2.19779 43.6615 1.48454 43.3098 0.95636V0.95636C42.9582 0.428179 42.2449 0.285082 41.7167 0.636743L16.4564 17.455C15.9282 17.8067 15.7851 18.5199 16.1367 19.0481V19.0481C16.4884 19.5763 17.2017 19.7194 17.7298 19.3677L42.9902 2.54946Z",
    fill: "#333333"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.29787,
    height: 22.6739,
    rx: 1.14894,
    transform: "matrix(0.648269 -0.761412 -0.761412 -0.648269 17.2642 20.0388)",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.eea732373483ee6ff29baeb44f61f553.svg";
export { ForwardRef as ReactComponent };